module.exports = __webpack_public_path__ + "img/balance-coin.ee1a8083.svg";